import { LocalStorageValue, SessionStoragesValue } from '@/types';
import { getQueryStringByName } from './helper';

const channelCode = getQueryStringByName('wapid');

const setLocal = (parms: { key: string; json: any; type: 'localStorage' | 'sessionStorage' }) => {
	const { key, json, type } = parms;
	try {
		const jsonStr = JSON.stringify(json);
		const channelKey = `${channelCode}_${key}`;
		if (type === 'localStorage') {
			window.localStorage.setItem(channelKey, jsonStr);
		} else {
			window.sessionStorage.setItem(channelKey, jsonStr);
		}
	} catch (error) {}
};

const getLocal = (parms: { key: string; type: 'localStorage' | 'sessionStorage' }): any => {
	const { key, type } = parms;
	try {
		let value;
		const channelKey = `${channelCode}_${key}`;
		if (type === 'localStorage') {
			value = window.localStorage.getItem(channelKey);
		} else {
			value = window.sessionStorage.getItem(channelKey);
		}
		return JSON.parse(value);
	} catch (error) {}
};

export const localStorageHelper = {
	get<T extends keyof LocalStorageValue>(key: T): LocalStorageValue[T] | void {
		return getLocal({ key, type: 'localStorage' });
	},
	set<T extends keyof LocalStorageValue>(key: T, obj): LocalStorageValue[T] | void {
		return setLocal({ key, type: 'localStorage', json: obj });
	},
};
export const sessionStorageHelper = {
	get<T extends keyof SessionStoragesValue>(key: T): SessionStoragesValue[T] | void {
		return getLocal({ key, type: 'sessionStorage' });
	},
	set<T extends keyof SessionStoragesValue>(key: T, obj): SessionStoragesValue[T] | void {
		return setLocal({ key, type: 'sessionStorage', json: obj });
	},
	remove<T extends keyof SessionStoragesValue>(key: T): void {
		const channelKey = `${channelCode}_${key}`;
		window.sessionStorage.removeItem(channelKey);
	},
};
